/**
 * Bindet ein externes `<script>`-Tag einmalig ein — nur im Produktionsbuild.
 *
 * Extrahiert aus `lib/analytics.ts` (GA4) und `lib/ads.ts` (AdSense), die
 * beide unabhängig voneinander dasselbe Muster implementiert hatten: eine
 * URL, einmal pro Seitenaufbau, nie in Entwicklung/Tests (sonst würden lokale
 * Läufe die Statistik verfälschen bzw. Auto-Ads-Fehler in der Konsole
 * erzeugen, weil die Domain bei Google nicht freigeschaltet ist).
 */
const loadedScriptSrcs = new Set<string>()

export type LoadScriptOnceOptions = {
  crossOrigin?: 'anonymous'
}

export function loadScriptOnce(src: string, options: LoadScriptOnceOptions = {}): void {
  if (typeof document === 'undefined') return
  if (loadedScriptSrcs.has(src)) return
  // In Entwicklung und Tests wuerde das Skript nur die Zahlen verfaelschen
  // (Analytics) oder Fehler erzeugen (AdSense, Domain nicht freigeschaltet).
  if (!import.meta.env.PROD) return

  loadedScriptSrcs.add(src)

  const script = document.createElement('script')
  script.async = true
  script.src = src
  if (options.crossOrigin) script.crossOrigin = options.crossOrigin
  document.head.appendChild(script)
}
